import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import { colors } from 'common/constants';
import { useAppDispatch } from 'common/hook';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getCampaignAnalyticsQuestionDetail } from 'services/campaign.service';
import { ICampaignAnalyticsQuestionDetail } from 'types/campaign';
import { IPagination } from 'types/type.global';
import { handleError } from 'utils/helpers';
interface IProps {
    questionId: string;
}
const QuestionTableDetail: React.FC<IProps> = ({ questionId }) => {
    const dispatch = useAppDispatch();
    const [pagination, setPagination] = useState<IPagination>({
        page: 1,
        per_page: 10,
    });
    const campaignId = useParams<{ id: string }>().id;
    const [questionDetail, setQuestionDetail] =
        useState<ICampaignAnalyticsQuestionDetail | null>();

    useEffect(() => {
        const fetchQuestionDetail = async () => {
            try {
                const response = await getCampaignAnalyticsQuestionDetail(
                    Number(campaignId),
                    Number(questionId),
                    pagination
                );
                if (response.success && response.data) {
                    setQuestionDetail((prev) => ({
                        ...response.data,
                        answers: [
                            ...(prev?.answers || []),
                            ...(response.data.answers || []),
                        ],
                    }));
                }
            } catch (error) {
                handleError(error);
            }
        };

        fetchQuestionDetail();
    }, [questionId, campaignId, pagination, dispatch]);
    return (
        <Box>
            <TableContainer component={Paper}>
                <Table
                    sx={{ minWidth: 650 }}
                    aria-label="question details table"
                >
                    <TableHead
                        sx={{
                            backgroundColor: '#D4E3FF',
                        }}
                    >
                        <TableRow>
                            <TableCell>Đáp án trả lời</TableCell>
                            <TableCell align="right">Người trả lời</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {questionDetail?.answers.map((item, index) => (
                            <TableRow
                                key={index}
                                sx={{
                                    '&:last-child td, &:last-child th': {
                                        border: 0,
                                    },
                                }}
                            >
                                <TableCell component="th" scope="row">
                                    {item.attributes.text}
                                </TableCell>
                                <TableCell align="right">
                                    {item.attributes.email}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {(questionDetail?.pagination?.total_page ?? 0) >
                pagination.page && (
                <Typography
                    onClick={() =>
                        setPagination({
                            ...pagination,
                            page: pagination.page + 1,
                        })
                    }
                    sx={{
                        fontSize: '16px',
                        fontWeight: '600',
                        color: colors.main,
                        cursor: 'pointer',
                        textAlign: 'center',
                        mt: 2,
                    }}
                >
                    Xem thêm ({pagination.page}/
                    {questionDetail?.pagination?.total_page})
                </Typography>
            )}
        </Box>
    );
};

export default QuestionTableDetail;
